import { FormikErrors, FormikProps, withFormik } from 'formik'
import { t } from 'i18next'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Form } from '@lib/formik'

import { Body1 } from '@ui/Typography'
import { PopoverInput } from '@ui/components/Popover'

import { FormSubmitValues } from '@utils/formValidation'

import { NameDto } from '@model/NameDto'

import { Box } from '@shared/components/Box'

export interface DateFormatFormValues {
  dateFormatTypeId: number
}

const DateFormatFormUI: React.FC<FormikProps<DateFormatFormValues> & OuterProps> = (props) => {
  const { dateFormats, values, handleSubmit, setSubmitting } = props

  const { t } = useTranslation()

  const handleChangeDateFormat = () => {
    setSubmitting(true)
    handleSubmit()
  }

  return (
    <Box flex gap='x24' direction='column'>
      <Body1>{t('Profile.Choose suitable date format')}</Body1>
      <Form>
        <PopoverInput
          name='dateFormatTypeId'
          label={t('Profile.Date Format')}
          value={values.dateFormatTypeId}
          options={dateFormats}
          onChange={handleChangeDateFormat}
        />
      </Form>
    </Box>
  )
}

interface OuterProps {
  dateFormatTypeId?: number
  dateFormats: NameDto[]
  onSubmit(values: FormSubmitValues<DateFormatFormValues>): Promise<void>
}

const DEFAULT_DATE_FORMAT_TYPE_ID = 2

export const DateFormatForm = withFormik<OuterProps, DateFormatFormValues>({
  mapPropsToValues: ({ dateFormatTypeId }) => {
    return {
      dateFormatTypeId: dateFormatTypeId || DEFAULT_DATE_FORMAT_TYPE_ID,
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values)
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<DateFormatFormValues> = {}
    if (values.dateFormatTypeId == null) {
      errors.dateFormatTypeId = t('Validation.Required')
    }
    return errors
  },
  enableReinitialize: true,
})(DateFormatFormUI)
